module.exports = __webpack_public_path__ + "static/img/homeNavigation1.c53b573a.png";